import { SplashScreen } from '@/components/SplashScreen';
import { normalizeReturnURI } from '@/lib/redirectUtils';
import { useAuth } from '@workos-inc/authkit-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';
import { PageMeta } from '@/components/PageMeta';

const searchSchema = z.object({
  returnURI: z.string().optional(),
  signUp: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  component: Login,
  validateSearch: searchSchema,
});

function Login() {
  const { signIn, isLoading, user, signUp } = useAuth();
  const navigate = useNavigate();
  const { returnURI: rawReturnURI, signUp: signUpParam } = Route.useSearch();

  const returnURI = normalizeReturnURI(rawReturnURI);
  const isSignUp = signUpParam === 'true';

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (user) {
      navigate({ to: returnURI ?? '/' });
      return;
    }
    if (isSignUp) {
      signUp({ state: { returnTo: returnURI } });
    } else {
      signIn({ state: { returnTo: returnURI } });
    }
  }, [isLoading, returnURI, signUp, user, navigate, isSignUp, signIn]);

  return (
    <>
      <PageMeta title="Sign In" />
      <SplashScreen />
    </>
  );
}
